import React from 'react';
import ContentGrid from './ContentGrid';
import { getReadStoryIds } from './storyReadState';
export default function Stories(props) {
    return <ContentGrid {...props} stories readIds={getReadStoryIds()} />;
}
